// alterado - revisado

import {
    SvgIcon,
} from '@material-ui/core'

import { ReactComponent as consumirReservaSvg } from './consumirReserva.svg'

import { ReactComponent as preservarReservaSvg } from './preservarReserva.svg'



export const SvgIconConsumirReserva = ( props ) => {
    return (
        <SvgIcon
            component={consumirReservaSvg}
            viewBox="0 0 30 30"
            {...props}
        />        
    )
}

export const SvgIconPreservarReserva = ( props ) => {
    return (
        <SvgIcon
            component={preservarReservaSvg}
            viewBox="0 0 30 30"
            {...props}
        />        
    )
}